import styled from 'styled-components';

const TagTitle = styled.p`
  font-size: 14px;
  font-weight: bold;
  display: inline-block;
  grid-column-end: span 12;
  margin: 0;
  margin-right: 4px;
`;

export default TagTitle;
